import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconsModule } from 'wflow-ui';

@Component({
    selector: 'app-offline-overlay',
    imports: [IconsModule, TranslateModule],
    templateUrl: './offline-overlay.component.html',
    styleUrl: './offline-overlay.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OfflineOverlayComponent {}
